import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { LearningTrackingService } from "src/app/_services/learning-tracking.service";
import { IsEnableLearningTabByLearnerId, IsEnableLearningTabByLearnerIdError, IsEnableLearningTabByLearnerIdSuccess } from "./learning-tracking.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { of } from "rxjs";

@Injectable()
export class LearningTrackingStateEffects {
  constructor(
    private actions$: Actions,
    private learningTrackingService: LearningTrackingService
  ) {}

  public isEnableLearningTabByLearnerIdEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(IsEnableLearningTabByLearnerId),
      switchMap((payload) => 
        this.learningTrackingService.getIsEnableLearningTabByLearnerId$(payload.learnerId, payload.courseId).pipe(
          map((result: boolean) => {
            return IsEnableLearningTabByLearnerIdSuccess({isEnabledLearningTab: result});
          }),
          catchError((error) => {
            return of(IsEnableLearningTabByLearnerIdError({error: error}));
          })
        )
      )
    )
  )
}